import React, { useMemo } from 'react';

import styled from 'styled-components';

import { RingCentralRecordsContext } from './RingCentralRecordsContext';
import RingCentralRecordsData from './RingCentralRecordsData';
import RingCentralRecordsHeader from './RingCentralRecordsHeader';
import { useRingCentralRecordsPage } from './useRingCentralRecordsPage';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const RingCentralRecords = () => {
  const { items, loading, totalItemsCount, filters, setPage, setFilters } = useRingCentralRecordsPage();
  const contextValue = useMemo(
    () => ({
      items,
      loading,
      totalItemsCount,
      filters,
      setPage,
      setFilters,
    }),
    [items, loading, totalItemsCount, filters, setPage, setFilters]
  );

  return (
    <RingCentralRecordsContext.Provider value={contextValue}>
      <Container>
        <RingCentralRecordsHeader />
        <RingCentralRecordsData />
      </Container>
    </RingCentralRecordsContext.Provider>
  );
};

export default RingCentralRecords;
